
export { formatDistanceToNow } from "/codebuild/output/src2357269973/src/auction-chase-frontend/node_modules/date-fns/formatDistanceToNow.js"